import { groupBy_1, groupBy_1_Simple } from "./groupByShared.js";
export const groupByWithSel = (source, keySelector, elementSelector, comparer) => {
    if (comparer) {
        return groupBy_1(source, keySelector, elementSelector, comparer);
    }
    else {
        return groupBy_1_Simple(source, keySelector, elementSelector);
    }
};
